import React from 'react';
import {FallbackComponentProps} from "@webng/react-app-common";

export function ErrorPage({error}: FallbackComponentProps){
  // TODO:Timo braucht es hier noch style? (ich denke schon)
  // wie kann ich die seite aufrufen
  return <div className="">{error.message}</div>
}
